import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	UploadCodeListFileParams,
	uploadCodeListFile,
} from "Infrastructure/Api/ApiCustom";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { CODELIST_FILES_QUERY_KEY } from "../Queries/useCodeListFilesQuery";

type Options = {
	silent?: boolean;
};

export function useUploadFileMutation(options?: Options) {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();
	const silent = options?.silent ?? false;

	return useMutation({
		mutationFn: (params: UploadCodeListFileParams) =>
			uploadCodeListFile(params),
		onSuccess: () => {
			if (silent) return;
			showSnackbar("Soubor byl úspěšně nahrán", "success");
			queryClient.invalidateQueries({ queryKey: [CODELIST_FILES_QUERY_KEY] });
		},
		onError: (error: Error) => {
			if (silent) return;
			showSnackbar(error.message || "Chyba při nahrávání souboru", "error");
		},
	});
}
